<div class="plans-page">
  <h2 class="header page-section">Choose your <b>Monthly</b> or <b>Multi-Month Plan!</b></h2>
  <h5 class="sub-header"><b>Unlimited</b> talk, text and data access!</h5>
  <p class="smaller text-italic">Our <b>3-month plan</b> starting <b>$15/mo!</b> Try us out.</p>
  <section class="plans-section">
    <div class="subscription-months-part">
      <ng-container *ngFor="let item of subscriptionCycles">
        <div class="subscription-container" (click)="selectSubscription(item)"
          [class.selected]="item === selectedSubscription" [class.third-order]="item === 1">
          <p class="val smaller"><b>{{item}}-Month</b></p>
          <img src="/assets/icon/down-primary-arrow.svg" alt="Arrow" width="55" height="20" class="primary-arrow-down"
            *ngIf="item === selectedSubscription">
        </div>
      </ng-container>
      <img src="/assets/img/plans-best-value-arrow.svg" class="offer-arrow" alt="Introductory Offer Image" width="184"
        height="86" *ngIf="innerWidth > 1599">
      <img src="/assets/img/plans-best-value-arrow-bp.svg" class="offer-arrow" alt="Introductory Offer Image"
        width="113" height="87" *ngIf="innerWidth > 639 && innerWidth < 1600">
      <img src="/assets/img/plans-best-value-arrow-mobile.svg" class="offer-arrow" alt="Introductory Offer Image"
        width="86" height="70" *ngIf="innerWidth > 468 && innerWidth < 640">
      <img src="/assets/img/plans-best-value-arrow-mobile-bp.svg" class="offer-arrow" alt="Introductory Offer Image"
        width="13" height="25" *ngIf="innerWidth < 469">
    </div>
    <div class="change-plan-cards-part">
      <div class="desktop-plans">
        <ng-container *ngFor="let plan of subscriptionPlans; let i = index;">
          <div class="plan-card" [class.focus]="plan?.category?.toLowerCase() === 'popular'" *ngIf="plan?.subscriptionCycles === selectedSubscription">
            <div class="intro-offer-section" *ngIf="selectedSubscription === SUBSCIPTION_DURATIONS.THREE_MONTHS">
              <img [src]="plan?.category?.toLowerCase() === 'popular' ? '/assets/icon/white-intro-promo-label.svg': '/assets/icon/intro-promo-label.svg'" alt="promo" class="promo-label" width="109" height="26">
              <p class="footer intro-offer">Introductory Offer</p>
            </div>
            <div class="internal-card-paddings">
              <div class="card-header">
                <p class="category">{{plan?.category | uppercase}}
                </p>
              </div>
              <div class="plan-info">
                <div class="data info" *ngIf="plan?.details?.data > 0">
                  <p class="amount" [class.unlimited]="plan?.category === 'Unlimited'">{{plan?.details?.data/1024 < 1 ?
                    plan?.details?.data : plan?.category==='Unlimited' ? 'Unlimited' : plan?.details?.data/1024
                    }}<span class="gb">{{plan?.details?.data/1024 < 1 ? 'MB' : plan?.category==='Unlimited' ? ''
                      : 'GB' }}</span></p>
                  <p class="smallest medium-font">High-speed 5G data</p>
                </div>
                <div class="data info" *ngIf="plan?.details?.data <= 0">
                  <p class="amount unlimited">Talk & Text</p>
                  <p class="smallest">5G / 4G LTE Network</p>
                </div>
                <div class="border"></div>
                <div class="price info">
                  <div class="intro-price">
                    <p class="dollar">$</p>
                    <p class="price-amount">{{!!plan?.promoMoPrice ? plan?.promoMoPrice : plan?.price}}</p>
                  </div>
                  <p class="smallest  medium-font">per month <span class="tooltip"
                    *ngIf="selectedSubscription === SUBSCIPTION_DURATIONS.THREE_MONTHS"><img
                      src="assets/icon/small-orange-info-icon.svg"
                      class="info-icon" alt="Info Icon" width="16" height="16">
                    <div class="tooltipInfo">
                      <p class="smallest">The Intro 3-month price is <b>${{plan?.promoMoPrice}}/mo</b>, you will be
                        charged a total of <b>${{plan?.subscriptionCycles * plan?.promoMoPrice}}</b>.</p>
                      <p class="smallest">After that the subscription will auto renew at <b>${{plan?.price}}/mo</b>, &
                        you will be charged a total of <b>${{plan?.subscriptionCycles * plan?.price}}</b>.</p>
                    </div>
                  </span></p>
                </div>
              </div>
              <div class="action">
                <button class="button" [ngClass]="{ 'secondary': plan?.category?.toLowerCase() === 'popular', 'primary': plan?.category?.toLowerCase() !== 'popular' }"
                  (click)="addPlanToCart.emit(plan)">Subscribe Now | ${{plan?.subscriptionCycles *
                  plan?.promoMoPrice}}</button>
                <button class="button tertiary" (click)="goToPlanDetails(plan?.id)"
                aria-label="View Plan Details">View Plan Details</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="plans-swiper-container swiper-container">
        <div class="swiper-wrapper">
          <ng-container *ngFor="let plan of subscriptionPlans; let i = index;">
            <div class="swiper-slide plan-card" *ngIf="plan?.subscriptionCycles === selectedSubscription">
              <h4 class="category">{{plan?.category | uppercase}}</h4>
              <p class="per smaller">{{plan?.subscriptionCycles}}-Month</p>
              <div class="intro-offer-section" *ngIf="selectedSubscription === SUBSCIPTION_DURATIONS.THREE_MONTHS">
                <p class="caption intro">{{ innerWidth > 639 ? 'Introductory' : 'Intro'}} Offer</p>
              </div>
              <div class="price-details">
                <div class="data-part" *ngIf="plan?.details?.data > 0">
                  <p class="value" [class.unlimited]="plan?.category === 'Unlimited'">{{plan?.details?.data/1024 < 1 ?
                      plan?.details?.data : plan?.category==='Unlimited' ? 'Unlimited' : plan?.details?.data/1024
                      }}<span class="gb">{{plan?.details?.data/1024 < 1 ? 'MB' : plan?.category==='Unlimited' ? ''
                        : 'GB' }}</span>
                  </p>
                  <p class="smallest">High-speed 5G data</p>
                </div>
                <div class="data-part" *ngIf="plan?.details?.data <= 0">
                  <p class="value talk">TALK & TEXT</p>
                  <p class="smallest">5G / 4G LTE Network</p>
                </div>
                <div class="border"></div>
                <div class="price-part">
                  <p class="value"><sup>$</sup>{{!!plan?.promoMoPrice ? plan?.promoMoPrice : plan?.price}}</p>
                  <p class="smallest">per month <span class="tooltip"
                      *ngIf="selectedSubscription === SUBSCIPTION_DURATIONS.THREE_MONTHS"><img
                        [src]="innerWidth > 639 && innerWidth < 1600 ? 'assets/icon/small-white-info-icon.svg' : 'assets/icon/small-orange-info-icon.svg'"
                        class="info-icon" alt="Info Icon" width="16" height="16">
                      <div class="tooltipInfo">
                        <p class="smallest">The Intro 3-month price is <b>${{plan?.promoMoPrice}}/mo</b>, you will be
                          charged a total of <b>${{plan?.subscriptionCycles * plan?.promoMoPrice}}</b>.</p>
                        <p class="smallest">After that the subscription will auto renew at <b>${{plan?.price}}/mo</b>, &
                          you will be charged a total of <b>${{plan?.subscriptionCycles * plan?.price}}</b>.</p>
                      </div>
                    </span></p>
                </div>
              </div>
              <div class="action">
                <button class="button"
                  [ngClass]="{ 'secondary': i === activeSlideIndex && innerWidth > 639, 'primary': i !== activeSlideIndex || innerWidth < 640 }"
                  (click)="addPlanToCart.emit(plan)">Subscribe Now | ${{plan?.promoMoPrice
                  * plan?.subscriptionCycles}}</button>
              </div>
              <a class="view-plan-details" (click)="goToPlanDetails(plan?.id)">View Plan Details</a>
              <p class="desc smallest">
                <span *ngIf="!!planDescBefore">{{planDescBefore}}</span>
                ${{plan?.promoMoPrice}}<span *ngIf="!!planDescAfter"> {{planDescAfter}}<span
                    *ngIf="!!planDescAfterSndLine"><br>{{planDescAfterSndLine}}</span></span>
              </p>
            </div>
          </ng-container>
        </div>
        <div class="hand-swiper">
          <img src="/assets/icon/hand-swipe.svg" alt="hand-swipe" width="32" height="32">
          <p class="caption swipe-note">Swipe right</p>
        </div>
        <ul class="slick-dots plan-dots slider-pagination"></ul>
      </div>
    </div>
    <div class="never-miss-payment-box" *ngIf="selectedSubscription === SUBSCIPTION_DURATIONS.ONE_MONTH">
      <h5 class="box-title">Never miss a payment!</h5>
      <p class="smaller box-note">Just set up Auto Renewal when subscribing to any plan and lock in our pricing.</p>
        <img src="/assets/img/hooray-img.svg" class="hooray-img" alt="Hooray Image" width="127" height="118">
        <img src="/assets/img/hooray-img.svg" class="hooray-img flip" alt="Hooray Image" width="127" height="118">
    </div>
  </section>
  <section class="page-section">
    <div class="broadband-facts-section">
      <div class="special-loading" *ngIf="loadingIdentifiers"></div>
      <h1 class="title">FreeUp Mobile Plan's Facts</h1>
      <h5 class="subtitle">Select a Subscription cycle to view the breakdown of prices and fees:</h5>
      <div class="subscription-months-part">
        <ng-container *ngFor="let item of subscriptionCycles">
          <div class="subscription-container" (click)="selectSubscription(item)"
            [class.selected]="item === selectedSubscription" [class.third-order]="item === 1">
            <p class="val smaller"><b>{{item}}</b><b>{{innerWidth > 639 ? '-Month' :
                '-Mo'}}</b></p>
          </div>
        </ng-container>
      </div>
      <div class="broadband-scrollable" >
        <div class="broadband-container" >
          <lib-plan-broadband-facts *ngFor="let plan of subscriptionPlans" [language]="'en'" [info]="info" [plan]="plan"
              (redirectToHowItWorks)="goToHowITWorks()" (redirectToNetworkManagement)="goToNetworkManagement()"
              (redirectToPrivacyPolicy)="goToPrivacyPolicy()" (redirectToWebsite)="goToWebsite()"
              class="plan-broadbands" [@fadeInOut]="animationState"></lib-plan-broadband-facts>
        </div>
      </div>
    </div>
  </section>
  <section class="plans-include-section page-section">
    <h2 class="title">All FreeUp Plans Include:</h2>
    <h4 class="sub-title"><b>Unlimited</b> talk, text + data access and <b>more!</b></h4>
    <div class="flex-content">
      <div class="flex-part">
        <div class="flex-point">
          <div class="point-icon">
            <img src="assets/img/blazing-fast-icon.svg" alt="Point Icon">
          </div>
          <div class="point-content">
            <h5 class="title">Blazing Fast 5G Network</h5>
            <p class="description">Premium wireless service powered by nation’s most reliable<br>5G - 4G LTE networks.
            </p>
          </div>
        </div>
        <div class="flex-point">
          <div class="point-icon">
            <img src="assets/img/best-coverage-icon.svg" alt="Point Icon">
          </div>
          <div class="point-content">
            <h5 class="title">Best Nationwide Coverage</h5>
            <p class="description">From coast to coast, we're powered by the nation’s largest and most trusted
              networks.</p>
          </div>
        </div>
      </div>
      <div class="flex-part">
        <div class="flex-point">
          <div class="point-icon">
            <img src="assets/img/wifi-calling-icon.svg" alt="Point Icon">
          </div>
          <div class="point-content">
            <h5 class="title">Wi-Fi Calling</h5>
            <p class="description">Talk at any place you have access to Wi-Fi in. Just set it up right from your
              smartphone settings. It’s easy to use!</p>
          </div>
        </div>
        <div class="flex-point">
          <div class="point-icon">
            <img src="assets/img/bring-number-icon.svg" alt="Point Icon">
          </div>
          <div class="point-content">
            <h5 class="title">Bring Your Number & The Phone You Love!</h5>
            <p class="description">Switch to FreeUp is easy. Keep your phone, keep your number. Or, let it go and start
              fresh with us.</p>
          </div>
        </div>
      </div>
      <div class="flex-part">
        <div class="flex-point truck">
          <div class="point-icon">
            <img src="assets/img/sim-shipping-icon.svg" alt="Point Icon">
          </div>
          <div class="point-content">
            <h5 class="title">FREE SIM Card + FREE Shipping</h5>
            <p class="description">Choose one of our unlimited data plans and get a free SIM card + free shipping.</p>
          </div>
        </div>
        <div class="flex-point">
          <div class="point-icon">
            <img src="assets/img/free-global-calling-icon.svg" alt="Point Icon">
          </div>
          <div class="point-content">
            <h5 class="title">Free Global Calling</h5>
            <p class="description">Enjoy unlimited Global calling to over 150+ destinations including Mexico and
              Canada.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="feedback-section">
    <div class="page-section">
      <h2 class="section-title">What Do Our Customers Say?</h2>
      <h5 class="info">We grow as individuals by contributing the best to community</h5>
    </div>
    <div class="swiper-actions">
      <div class="swiper-button-next testimonial-swiper-button-next"></div>
      <div class="swiper-button-prev testimonial-swiper-button-prev"></div>
    </div>
    <div class="cards-section">
      <div class="testimonial-swiper-container swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide feedback-card" *ngFor="let slide of slides">
            <div class="images-row">
              <img class="avatar" alt="avatar" [src]="slide?.fields?.avatar?.fields?.file?.url" width="80"
                height="80" />
              <img class="stars" alt="stars" src="assets/img/stars.svg" width="100" height="20" />
            </div>
            <p class="content">{{slide?.fields?.userMessage}}</p>
            <div class="details-section">
              <div class="user">
                <p class="name">{{slide?.fields?.userDetails.split(',')[0]}}</p>
                <p class="state">{{slide?.fields?.userDetails.split(',')[1]}}</p>
              </div>
              <div class="testemonial">
                <img src="assets/icon/like.svg" alt="like" width="16" height="16" />
                <p class="title">Testimonial</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="backdrop"></div>
    </div>
    <div class="swipe">
      <img src="assets/img/swipe.svg" alt="swipe left and right" width="28" height="35" />
      <p class="swipe-note caption"><b>Swipe right</b></p>
    </div>
  </section>
</div>